import { Button } from '@eb/eds-button';
import { gettext } from '@eb/i18n';
import React, { useContext } from 'react';
import { ReadMoreContext } from './context';
import './ReadMore.scss';
import { ReadMoreToggleProps } from './types';

const readMoreToggleDefaults: ReadMoreToggleProps = {
    labels: {
        show: gettext('Show more'),
        hide: gettext('Show less'),
    },
};

export const ReadMoreToggle: React.FunctionComponent<ReadMoreToggleProps> = (
    props,
) => {
    const { isExpanded, setExpanded, isClamped } = useContext(ReadMoreContext);

    if (!isClamped) {
        return null;
    }

    return (
        <div className="read-more__toggle">
            <Button
                data-testid="read-more-toggle"
                style="none"
                onClick={() => {
                    setExpanded?.(!isExpanded);
                }}
            >
                <span className="eds-link">
                    {isExpanded ? props.labels?.hide : props.labels?.show}
                </span>
            </Button>
        </div>
    );
};

ReadMoreToggle.defaultProps = readMoreToggleDefaults;
